export enum RiskStatusEnum {
  AT_RISK = "At risk",
  AT_DANGER = "At danger",
  DELAYED = "Delayed",
}
